import { lazy } from "@/valor-utils/lazy";

import { Theme } from "./Theme";

const LazyApp = lazy("box", () => import("./App").then((mod) => mod.App));

export const AppLoader = () => (
  <Theme>
    <LazyApp />
  </Theme>
);
